<ng-container *ngIf="arrayLang.length === 1; else multilang">
  <span class="lang-select single-select">
    <img src="./assets/img/icons/icon-{{ langSelect }}.svg" alt="flag" class="img-flag"/>
     <span class="text" *ngIf="showText">
      {{ langSelect | translate }}
     </span>
  </span>
</ng-container>
<ng-template #multilang>
  <span [matMenuTriggerFor]="langMenu" class="lang-select multilang-select">
    <img src="./assets/img/icons/icon-{{ langSelect }}.svg" alt="flag" class="img-flag"/>
     <span class="text" *ngIf="showText">
      {{ langSelect | translate }}
     </span>
  </span>
  <mat-menu #langMenu class="language-menu">
    <button mat-menu-item [ngStyle]="{ display: 'none' }"></button>
    <button mat-menu-item *ngFor="let language of arrayLang"
      (click)="onSelect(language)">
      <img src="./assets/img/icons/icon-{{ language }}.svg" alt="flag" class="img-flag-item"/>
      <span>{{ language | translate }}</span>
    </button>
  </mat-menu>
</ng-template>
